var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.5 54.0273L25.5 27.501L1.5 0.974724","stroke":"white","strokeWidth":"2"}));
}

ArrowRight.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 27 55","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
